import React from 'react'

const Pyramid = () => {
  return (
    <div>
      
    </div>
  )
}

export default Pyramid
